import TextField from '@components/v2/form/TextField/TextField';
import LangEnum from '../../../../lang/LangEnum';
import { onlyNumbers } from '../../../../utils/validators';
import { useTranslation } from '../../../translation/TranslationContext';
import SettingContainer from '../../SettingContainer';
import { ProductInputLockSectionGeneralSettingsProps } from '../types/GeneralSettings.types';

const ProductInputLockSectionGeneralSettings = ({
  generalSettings,
  handleChange,
  handleBlur,
}: ProductInputLockSectionGeneralSettingsProps) => {
  const { translate } = useTranslation();

  return (
    <SettingContainer
      title={translate(LangEnum.GENERAL_SETTINGS_PRODUCT_INPUT_LOCK_VALUE)}
      description={LangEnum.GENERAL_SETTINGS_PRODUCT_INPUT_LOCK_VALUE_DESCRIPTION}
    >
      <TextField
        label={translate(LangEnum.GENERAL_SETTINGS_PRODUCT_INPUT_LOCK_MAX_LABEL)}
        name="productInputLockValue"
        value={generalSettings.productInputLockValue ?? ''}
        slotProps={{
          inputLabel: { shrink: generalSettings.productInputLockValue != null },
          htmlInput: { maxLength: 2 },
        }}
        onBlur={() => handleBlur()}
        onChange={(event) =>
          handleChange({
            value: Number(onlyNumbers(event.target.value)),
            name: 'productInputLockValue',
          })
        }
      />
    </SettingContainer>
  );
};

export default ProductInputLockSectionGeneralSettings;
